<template>
  <shell>
    <sidebar-shell>
      <ul class="flex-col space-y-8 mt-16 hidden lg:flex">
        <li
          v-for="(step, index) in steps"
          :key="step"
          class="opacity-50 first:opacity-100 flex items-center space-x-5 "
        >
          <typography
            class="h-8 w-8 flex items-center text-center justify-center rounded-full bg-white text-primary font-bold"
            variant="p"
            >{{ index + 1 }}</typography
          >
          <typography class="text-white" variant="h6">{{ step }}</typography>
        </li>
      </ul>
    </sidebar-shell>

    <div class="px-8 py-10 lg:px-24 lg:pb-16 lg:pt-40">

      <onboarding-header :current-step="1" :total-steps="3">
        <template v-slot:header>
          Name your first project
        </template>
        <template v-slot:description>
          Projects are the websites or applications that you'll be creating a search database for.
        </template>
      </onboarding-header>

      <FormulateForm @submit="createProject" :values="project" class="mt-8">
        <label class="text-sm text-gray-500 leading-8" for="name">Project name...</label>
        <base-input autofocus required placeholder="Enter your project name..." id="name" name="name" />

        <base-button bgColor="bg-success dark:bg-green-600" borderColor="border-success dark:border-green-500" hoverBg="hover:bg-green-400 dark-hover:bg-green-500" hoverBorder="hover:border-success-400" class="mt-10" icon="project" iconPosition="left"   type="submit">Create Project</base-button>
      </FormulateForm>
    </div>
  </shell>
</template>

<script>
import Shell from "@/modules/Auth/components/Shell";
import SidebarShell from "@/modules/Auth/components/SidebarShell";
import OnboardingHeader from "../components/OnboardingHeader"
import { createProject, createCollection, updateAuthenticationState } from "@/graphql/mutations";
import { error, loading } from "@/mixins"

export default {
  name: "OnboardingPage",
  metaInfo: {
      title: 'Onboarding',
  },
  components: {
    Shell,
    SidebarShell,
    OnboardingHeader
  },
  mixins: [ error, loading ],
  data() {
    return {
      project: {
        name: ''
      },
      isSubmitting: false,
      steps: [
        "Create Your Project",
        "Update Your Profile",
        "Invite Your Team",
      ],
    };
  },
  methods: {
    async createProject(data) {

        if (this.isSubmitting) {
          return
        }

        this.isSubmitting = true;

        try {
            this.$root.$emit('loading', true);
            const project = await this.$apollo.mutate({
                mutation: createProject,
                variables: {
                    input: {
                        name: data.name
                    }
                },
            });

            const collection = await this.$apollo.mutate({
                mutation: createCollection,
                variables: {
                    input: {
                        projectId: project.data.createProject.project.id,
                        name: "My First Collection"
                    }
                },
            });

            console.log(collection);

            await this.$apollo.mutate({
                mutation: updateAuthenticationState,
                variables: {
                    selectedProject: project.data.createProject.project.id,
                    needsToOnboard: false
                }
            });

            this.$router.push({ name: 'OnboardingUpdateProfile'})
        } catch (error) {
            this.handleError(error);
        }

        this.$root.$emit('loading', false);

        this.isSubmitting = false;
    },
  },
};
</script>
